/* Sticky announcement bar — standalone add-on.
 * Makes the announcement bar's section sticky and keeps a CSS variable
 * (--mrk-ann-h) in sync with its height so the sticky header offsets below it.
 * No dependencies.
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var section = bar.closest('.shopify-section') || bar.parentElement;
    if (!section) return;

    section.classList.add('mrk-sticky-ann');
    // Apply the sticky positioning inline (with importance) so it can't be
    // overridden by a theme rule on .shopify-section.
    section.style.setProperty('position', 'sticky', 'important');
    section.style.setProperty('top', '0px', 'important');
    section.style.setProperty('z-index', '8', 'important');

    var onCollection = !!window.mrkStickyAnnCollection;
    if (onCollection) {
      document.documentElement.classList.add('mrk-sticky-ann-collection');
    }

    // Measure the FULL sticky header wrapper (.header-section) — it includes every
    // header row (e.g. the mobile navigation bar), unlike the inner #header-component.
    var header = document.querySelector('.header-section') || document.getElementById('header-component');
    var stackPx = 0;

    function setHeight() {
      var annH = Math.round(section.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--mrk-ann-h', annH + 'px');
      // Total sticky stack (announcement + header) — used to offset the sticky
      // collection filters. Measured so it's correct on mobile and desktop.
      var hdrH = header ? Math.round(header.getBoundingClientRect().height) : 60;
      stackPx = annH + hdrH;
      document.documentElement.style.setProperty('--mrk-stack-h', stackPx + 'px');
      offsetStickyFilters();
    }

    // Offset Boost's sticky filter bar so it parks below the announcement + header
    // instead of sliding underneath them (which looks "cut off").
    //
    // Boost's markup differs between desktop and mobile (confirmed by live DOM):
    //   - Desktop: the horizontal filter/toolbar is `position: sticky`.
    //   - Mobile:  the sticky sort/toolbar bar is `position: FIXED` on a
    //              `boost-sd__toolbar-item` and Boost sets its top to the header
    //              height only (~59px), ignoring the announcement bar above it.
    //
    // So we run two passes:
    //   STICKY pass — broad filter containers, only when computed position is
    //                 `sticky`. Touching only sticky elements means a normal-flow
    //                 wrapper can never be shoved behind the product tiles.
    //   FIXED  pass — TOOLBAR items only, only when computed position is `fixed`.
    //                 Scoping to toolbar items is critical: Boost's full-screen
    //                 overlays (filter drawer, search) are also `fixed` but live at
    //                 top:0 with huge z-indexes and MUST stay pinned there.
    var STICKY_CANDIDATES =
      '[class*="boost-sd__toolbar"], [class*="boost-sd__filter-tree"], ' +
      '[class*="boost-sd__refine"], [class*="boost-sd__sticky"], [class*="boost-sd__sortby"]';
    var FIXED_CANDIDATES = '[class*="boost-sd__toolbar"]';

    function offsetStickyFilters() {
      if (!onCollection || !stackPx) return;
      var want = stackPx + 'px';
      applyTop(STICKY_CANDIDATES, 'sticky', want);
      applyTop(FIXED_CANDIDATES, 'fixed', want);
    }

    function applyTop(selector, positionWanted, want) {
      var nodes = document.querySelectorAll(selector);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (window.getComputedStyle(el).position !== positionWanted) continue;
        // Only write when the value actually changes — writing the same value
        // would re-trigger the style MutationObserver and loop forever.
        if (el.style.top !== want) {
          el.style.setProperty('top', want, 'important');
        }
      }
    }

    setHeight();
    window.addEventListener('load', setHeight);
    window.addEventListener('resize', setHeight);
    window.addEventListener('orientationchange', setHeight);
    if ('ResizeObserver' in window) {
      try { new ResizeObserver(setHeight).observe(section); } catch (e) { /* noop */ }
    }

    if (onCollection) {
      var pending = false;
      function scheduleOffset() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; offsetStickyFilters(); });
      }
      // Re-apply on scroll — Boost may only switch the bar to `position: sticky`
      // (via a class) once you scroll to it, so we must re-check past load.
      window.addEventListener('scroll', scheduleOffset, { passive: true });
      // Boost re-renders the grid/filters on filter, sort, paginate and breakpoint
      // changes, and toggles classes, either of which can drop our inline `top`.
      if ('MutationObserver' in window) {
        new MutationObserver(scheduleOffset).observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
